import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { setUserClickData } from "../../utility/setUserClickData"; 

export default function LoanOfferPage() {
  const [params] = useSearchParams();
  const [loadingId, setLoadingId] = useState(null);

  const leadId = params.get("lid") || params.get("ld_id") || "";
  const affId = params.get("aff_id") || "";
  const utmSource = params.get("utm_source") || "";
  const utmMedium = params.get("utm_medium") || "";
  const utmCampaign = params.get("utm_campaign") || "";
  const utmTerm = params.get("utm_term") || "";
  const source = params.get("source") || "";
  const adsName = params.get("ads_name") || "";

  const hardcodedOffers = [
    {
      id: "flot_1",
      lenderName: "Flot",
      logo: "/assets/bank_img/logo/Flot.png",
      baseUrl: "https://myflot.com/?utm_source=Digitmoney&utm_medium=SMS&utm_campaign=", 
      amount: "upto 2 Lakhs",
      interest: "0.1% to 1%",
      interestSuffix: "/ day",
      eventName: "direct_campaign_clicked_flot_offer"
    },
    {
      id: "credsea_1",
      lenderName: "Creditsea",
      logo: "/assets/bank_img/logo/creditsea.png",
      baseUrl: "https://www.creditsea.com/onboarding/sign-up/enter-mobile?source=28710364",
      amount: "upto 2 Lakhs",
      interest: "0.3%",
      interestSuffix: "/ day",
      eventName: "direct_campaign_clicked_creditsea_offer"
    },
  ];

  const handleCompleteApplication = async (offer) => {
    setLoadingId(offer.id);

    try {
      await setUserClickData({
        event_name: offer.eventName, 
        user_id: leadId || "unknown_lead",
        affiliate_id: affId || "No Aff_id found",
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_term: utmTerm,
      });

      const redirectUrl = new URL(offer.baseUrl);
      
      if (offer.lenderName === "Flot") {
        redirectUrl.searchParams.set("utm_campaign", leadId || utmCampaign || "");
      } else if (utmCampaign) {
        redirectUrl.searchParams.set("utm_campaign", utmCampaign);
      }

      if (leadId && offer.lenderName !== "Flot" && offer.lenderName !== "Creditsea") {
        redirectUrl.searchParams.set("lid", leadId);
      }
      
      if (utmSource) {
        redirectUrl.searchParams.set("utm_source", utmSource);
      }
      
      if (utmMedium && offer.lenderName !== "Creditsea") {
        redirectUrl.searchParams.set("utm_medium", utmMedium);
      }
      
      if (utmTerm) redirectUrl.searchParams.set("utm_term", utmTerm);
      if (source) redirectUrl.searchParams.set("source", source);
      if (adsName) redirectUrl.searchParams.set("ads_name", adsName);
      
      window.open(redirectUrl.toString(), "_blank", "noopener,noreferrer");
      
      setTimeout(() => setLoadingId(null), 1000);
      
    } catch (error) {
      console.error("Error saving data before redirect:", error);
      setLoadingId(null);
    }
  };

  return (
    <div className="max-w-[400px] mx-auto min-h-screen relative font-sans text-[#1b1b1b] pb-[160px] overflow-hidden bg-gradient-to-b from-[#f4fcf6] to-[#e4f7eb]">
      
      <div className="bg-transparent px-4 pt-6 pb-2">
        <div className="flex justify-center w-full items-center mb-10 pt-2">
          <img src="/assets/img/Footer logo.png" alt="Digitmoney Logo" className="h-auto w-[180px]" />
        </div>

        <div className="flex items-center justify-center mb-1">
          <h2 className="text-center font-bold text-[22px] tracking-tight text-[#113f28]">
            Congratulations 🎉
          </h2>
        </div>

        <p className="text-center text-[13px] leading-[1.35] text-[#1b1b1b]">
          <span className="text-[#ff7a1a] font-bold">
            2 lenders
          </span>{" "}
          matched your profile.
        </p>

        <p className="text-center text-[11px] leading-[1.4] mt-[6px] text-[#557b66]">
          You're one step away from funding your{" "}
          <b className="text-[#113f28]">“Purpose of Loan”</b>.
        </p>
      </div>

      <div className="px-4 mt-4 flex flex-col gap-5">
        {hardcodedOffers.map((offer) => (
          <div
            key={offer.id}
            className="bg-white rounded-[12px] border border-[#d6ebd9] px-4 py-3.5 shadow-[0_4px_16px_rgba(0,40,20,0.04)]"
          >
            <div className="flex justify-center items-center border-b border-[#eef5f0] pb-2.5 mb-3.5">
              <img 
                src={offer.logo} 
                alt={`${offer.lenderName} logo`} 
                className="h-8 max-w-[130px] object-contain" 
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <h3 style={{display: 'none'}} className="text-[16px] font-bold text-[#1b1b1b] italic">
                {offer.lenderName}
              </h3>
            </div>

            <div className="grid grid-cols-2 gap-2 mb-4 px-1">
              <div className="text-center border-r border-[#f0f0f0]">
                <p className="text-[#8b8b8b] text-[13px] mb-1 font-medium tracking-wide">Loan Amount</p>
                <h3 className="font-bold text-[18px] text-[#1b1b1b] tracking-tight">
                  {offer.amount}
                </h3>
              </div>
              <div className="text-center">
                <p className="text-[#8b8b8b] text-[13px] mb-1 font-medium tracking-wide">Interest</p>
                <p 
                  className="font-bold text-[#1b1b1b]" 
                  style={offer.lenderName === "Flot" ? { 
                    fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                    fontSize: '18px',
                    letterSpacing: '-0.3px',
                    fontWeight: '700'
                  } : { fontSize: '18px', fontWeight: '700' }}
                >
                  {offer.interest} <span className="text-[13px] font-medium text-[#8b8b8b] tracking-normal">{offer.interestSuffix}</span>
                </p>
              </div>
            </div>

            <button
              onClick={() => handleCompleteApplication(offer)}
              disabled={loadingId === offer.id}
              className="w-full bg-[#111111] text-white rounded-[10px] py-[10px] font-bold text-[14px] active:scale-[0.98] transition-transform disabled:opacity-70 flex justify-center items-center tracking-wide shadow-sm"
            >
              {loadingId === offer.id ? "Redirecting..." : "Complete your application"}
            </button>
          </div>
        ))}
      </div>

      <div className="fixed bottom-0 left-0 right-0 z-40">
        <div className="max-w-[400px] mx-auto bg-white/95 backdrop-blur-md px-5 pt-4 pb-6 border-t border-[#e8e8e8] shadow-[0_-4px_12px_rgba(0,0,0,0.03)]">
          <p className="text-left text-[#7a8c82] text-[10px] leading-[15px]">
            <b className="text-[#1b1b1b]">Disclaimer:</b> These pre-approved offers are subject to change at discretion of Bank / NBFC after receiving all your documents and details. Final offer will be based on risk policy of Bank / NBFC. We do not guarantee that final offer will be same as Pre-approved offer.
            <br />
            <br />
            <span className="italic">Note: You may receive calls from multiple lenders.</span>
          </p>
        </div>
      </div>
    </div>
  );
}